import { useEffect, useState } from "react";
import { useGlobalStore } from "~/stores/store-provider";
import ChatWindow from "~/components/chat/chat-window";
import TiptapEditor from "~/components/document-editor-v2/tiptap-editor";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { RiDraggable } from "react-icons/ri";

const LiveSession = ({ sessionId }: { sessionId: string }) => {
  const {
    collapsed,
    currentSession,
    sessionDocumentView,
    clearChatMessages,
    fetchChatMessages,
    fetchCurrentSession,
    resetAnalysisDocument,
  } = useGlobalStore((state: any) => state);

  const [isEditorExpanded, setIsEditorExpanded] = useState<boolean>(false);

  useEffect(() => {
    resetAnalysisDocument();
    clearChatMessages();
    fetchChatMessages(sessionId);
    fetchCurrentSession(sessionId);
  }, [sessionId]);

  return (
    <div className="h-full w-full">
      <div
        className={`fixed top-0 h-16 z-10 ${
          collapsed ? "left-12" : "left-78"
        } right-0 pt-4 bg-base-100 mask-b-from-70%`}
      >
        <h2 className="text-lg text-primary font-medium text-center">
          {currentSession?.title}
        </h2>
      </div>
      <div className="pt-16 h-full">
        {!isEditorExpanded ? (
          <PanelGroup
            direction="horizontal"
            autoSaveId="conditional"
            className="h-full w-full"
          >
            <Panel defaultSize={50} minSize={35}>
              <ChatWindow sessionId={sessionId} />
            </Panel>

            {sessionDocumentView && (
              <>
                <PanelResizeHandle className="group flex w-2 items-center justify-center bg-base-200 hover:bg-base-300 transition-colors duration-200 cursor-col-resize">
                  <div className="z-1 flex h-12 w-6 items-center justify-center rounded-md border border-base-300 bg-base-100 group-hover:bg-base-200 group-hover:border-base-400 transition-all duration-200 shadow-sm">
                    <RiDraggable className="h-4 w-4 text-base-content opacity-60 group-hover:opacity-100 transition-opacity duration-200" />
                  </div>
                </PanelResizeHandle>

                <Panel defaultSize={50} minSize={50}>
                  <div className="h-full overflow-auto">
                    <TiptapEditor
                      sessionId={sessionId}
                      isEditorExpanded={isEditorExpanded}
                      setIsEditorExpanded={setIsEditorExpanded}
                    />
                  </div>
                </Panel>
              </>
            )}
          </PanelGroup>
        ) : (
          sessionDocumentView && (
            <div className="h-full overflow-auto">
              <TiptapEditor
                sessionId={sessionId}
                isEditorExpanded={isEditorExpanded}
                setIsEditorExpanded={setIsEditorExpanded}
              />
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default LiveSession;
